"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.codeModificationApi = exports.removeCodeModification = exports.createCodeModification = exports.updateCodeModification = exports.getModificationsByTest = void 0;
const commonPayload = {
    input_type: 'modification',
    name: '',
    selector: '',
};
const getModificationsByTest = (caller) => ({ accountId, testId }) => {
    return caller(`/api/v1/accounts/${accountId}/tests/${testId}/modifications`).get({
        type: 'modification',
    });
};
exports.getModificationsByTest = getModificationsByTest;
const updateCodeModification = (caller) => ({ accountId, testId, modificationId, payload }) => {
    return caller(`/api/v1/accounts/${accountId}/tests/${testId}/modifications/${modificationId}`).patch({
        ...commonPayload,
        ...payload,
    });
};
exports.updateCodeModification = updateCodeModification;
const createCodeModification = (caller) => ({ accountId, testId, payload }) => {
    return caller(`/api/v1/accounts/${accountId}/tests/${testId}/modifications`).post({
        ...commonPayload,
        ...payload,
    });
};
exports.createCodeModification = createCodeModification;
const removeCodeModification = (caller) => ({ accountId, testId, modificationId }) => {
    return caller(`api/v1/accounts/${accountId}/tests/${testId}/modifications/${modificationId}?input_type=modification`).delete({
        input_type: 'modification',
    });
};
exports.removeCodeModification = removeCodeModification;
const codeModificationApi = (caller) => ({
    getModificationsByTest: (0, exports.getModificationsByTest)(caller),
    updateCodeModification: (0, exports.updateCodeModification)(caller),
    createCodeModification: (0, exports.createCodeModification)(caller),
    removeCodeModification: (0, exports.removeCodeModification)(caller),
});
exports.codeModificationApi = codeModificationApi;
//# sourceMappingURL=codeEditorApi.js.map